import React from "react";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import ModalSkeletonCssClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";

import {
  BalloonsIcon,
  CheckCircleIconGreen,
} from "../../../../../constant/imagePath";
import classes from "./Congrats.module.css";
import { Button } from "../../../../../stories/Button/Button";

export default function CongratsModal({ show, setShow }) {
  return (
    <>
      <style>{`
      .${ModalSkeletonCssClasses.body} {
        padding: 20px;
      }
      .${ModalSkeletonCssClasses.iconBox} {
        right: 20px;
      }
          
    `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        borderRadius={"20px"}
        modalClass={classes.modal}
        width={"376px"}
        showCloseIcon
      >
        <div className={classes.modalContent}>
          <div className="text-center">
            <img src={CheckCircleIconGreen} className={classes.img} />
          </div>
          <h4
            style={{
              ...Fonts.h4,
              fontSize: "26px",
              color: Colors.neutralShadesOfNero,
            }}
          >
            Congrats
          </h4>
          <p
            className={classes.firstLine}
            style={{
              ...Fonts.p2,
              color: Colors.neutralShadesOfDimGray,
            }}
          >
            Your evaluation has been submitted.
          </p>
        </div>
      </ModalSkeleton>
    </>
  );
}
